<template>
  <div class="container" v-if="isReady">
    <h1>Gestion du profil</h1>
    <b-form v-on:submit.prevent="soumettre" class="form-container">
      <template v-for="field in fields">
        <b-form-group
          :key="field.id"
          :label="field.label"
          :label-for="field.id"
          class="inputGroup"
        >
          <b-form-select
            v-if="field.type === 'select'"
            :id="field.id"
            v-model="item[field.id]"
            :options="forfaits"
            :text-field="field.textField"
            :value-field="field.valueField"
            :disabled="isGestionnaire"
          />

          <b-form-input
            v-else
            :required="field.required"
            :type="field.type"
            :id="field.id"
            :placeholder="field.label"
            v-model="item[field.id]"
            :maxlength="field.maxLength"
            @input="
              if (field.id === 'phone') {
                item[field.id] = item[field.id].replace(/\D/g, '').slice(0, 10);
              } else if (field.id === 'poste') {
                item[field.id] = item[field.id].replace(/\D/g, '').slice(0, 5);
              }
            "
          />
        </b-form-group>
      </template>

      <div class="btnContainer">
        <b-button class="buttonSoumettre" type="submit">Soumettre</b-button>
        <div v-if="afficherReactiver" class="mt-3 alert alert-warning">
          <p>Cette entreprise existe déjà, mais elle est inactive.</p>
          <b-button variant="primary" @click="reactiverEntreprise">
            Réactiver cette entreprise
          </b-button>
        </div>

        <b-button class="buttonBack" @click="back()">Annuler</b-button>
      </div>

      <span
        style="color: red"
        v-for="erreur in listeErreurs"
        v-bind:key="erreur"
        >{{ erreur }}
        <br />
      </span>
    </b-form>

    <b-modal
      id="modal-chargement"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="true"
      centered
      hide-footer
      title="Chargement"
    >
      Chargement...
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "entrepriseSettings",
  /**
   * Initializes the component's data.
   *
   * @return {Object} The component's initial data.
   */
  data() {
    return {
      item: {},
      listeErreurs: [],
      entrepriseInactive: null,
      afficherReactiverEntreprise: false,
      isForfaitsLoaded: false,
      retourServeur: "",
      isReady: false,
      forfaits: [],
      wpRoles: [],
      newsletterLists: [],
    };
  },
  computed: {
    /**
     * Checks if the current route parameter 'id' is null, indicating a new item.
     *
     * @return {boolean} True if the 'id' parameter is null, false otherwise.
     */
    siNouveau() {
      return this.$route.params.id == null;
    },
    /**
     * Checks if the current user is a manager (gestionnaire).
     *
     * @return {boolean} True if the user role is 4, false otherwise.
     */
    isGestionnaire() {
      return parseInt(sessionStorage.getItem("role")) === 4;
    },
    /**
     * Returns an array of field objects, each containing id, label, type, and required properties.
     *
     * @return {Array} An array of field objects.
     */
    fields() {
      const fields = [
        {
          id: "name",
          label: "Nom de la compagnie",
          type: "text",
          required: true,
        },
        {
          id: "first_name",
          label: "Prénom de la personne ressource",
          type: "text",
          required: true,
        },
        {
          id: "last_name",
          label: "Nom de famille de la personne ressource",
          type: "text",
          required: true,
        },
        {
          id: "role",
          label: "Rôle de la personne ressource",
          type: "text",
          required: true,
        },
        {
          id: "phone",
          label: "Téléphone de la personne ressource",
          type: "tel",
          required: true,
          maxLength: 10,
        },
        {
          id: "poste",
          label: "Numéro de poste de la personne ressource",
          type: "tel",
          required: false,
          maxLength: 5,
        },
        {
          id: "email",
          label: "Courriel de la personne ressource",
          type: "email",
          required: true,
        },
        {
          id: "forfait_id",
          label: "Forfait",
          type: "select",
          valueField: "id",
          textField: "name",
          options: this.getForfaits,
        },
      ];

      return fields;
    },
  },
  methods: {
    getForfaits() {
      return this.forfaits;
    },
    soumettre() {
      this.listeErreurs = [];
      this.afficherReactiver = false;
      this.entrepriseInactive = null;

      if (!this.item.name)
        this.listeErreurs.push("Le nom de l'entreprise est requis");
      if (!this.item.first_name) this.listeErreurs.push("Le prénom est requis");
      if (!this.item.last_name)
        this.listeErreurs.push("Le nom de famille est requis");
      if (!this.item.role) this.listeErreurs.push("Le rôle est requis");
      if (!this.item.phone) this.listeErreurs.push("Le téléphone est requis");
      if (!this.item.email) this.listeErreurs.push("Le courriel est requis");

      if (this.listeErreurs.length === 0) {
        this.$bvModal.show("modal-chargement");
        this.$store
          .dispatch("entreprises/registerOrUpdateEntreprise", this.item)
          .then((response) => {
            this.$bvModal.hide("modal-chargement");

            if (response.status === 200) {
              const message = this.$route.params.id
                ? "L'entreprise a été modifiée avec succès"
                : "L'entreprise a été ajoutée avec succès";
              this.$toast.success(message, { duration: 5000 });
              this.$router.push({ name: "ListeEntreprises" });
            }
          })
          .catch((err) => {
            this.$bvModal.hide("modal-chargement");
            const data = err.response?.data;

            if (err.response?.status === 409 && data.inactive === true) {
              // L'entreprise existe mais est inactive
              this.entrepriseInactive = data.entreprise;
              this.afficherReactiver = true;
            } else {
              this.listeErreurs.push(
                "Une erreur est survenue lors de l'enregistrement."
              );
              console.error("Erreur", err.response?.data);
            }
          });
      }
    },
    reactiverEntreprise() {
      if (!this.entrepriseInactive?.id) return;

      this.$bvModal.show("modal-chargement");
      this.$store
        .dispatch(
          "entreprises/reactivateEntreprise",
          this.entrepriseInactive.id
        )
        .then((res) => {
          this.$toast.success("L'entreprise a été réactivée avec succès");
          this.$router.push({ name: "ListeEntreprises" });
        })
        .catch(() => {
          this.$toast.error("Erreur lors de la réactivation");
        });
    },
    back() {
      this.$router.push({ path: "/admin/liste-entreprises" });
    },
    /*async getWpRoles() {
      try {
        const response = await this.$axios.get("/wp-json/wp/v2/users/roles");
        this.wpRoles = Object.entries(response.data).map(([slug, role]) => ({
          slug,
          name: role.name,
        }));
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des rôles WordPress:",
          error
        );
        this.$toast.error("Impossible de récupérer les rôles WordPress");
      }
    },*/
  },
  created() {
    this.$store.dispatch("forfaits/getAllForfaits").then((forfaits) => {
      forfaits.push({
        id: null,
        name: "Aucun",
      });
      this.forfaits = forfaits;
      this.isForfaitsLoaded = true;
    });

    if (!this.siNouveau) {
      this.$store
        .dispatch("entreprises/getEntreprise", this.$route.params.id)
        .then((item) => {
          this.item = item;
          this.isReady = true;
        });
    } else {
      this.item = {};
      this.isReady = true;
    }
  },
};
</script>

<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: start;
  gap: 10px;
}
.container {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
}
.inputGroup {
  width: 100%;
}
.btnContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 100%;
}
</style>
